import { BlockProps } from "../../Models";

const BlockHeader = ({ section }: BlockProps) => {
    const content = typeof section.content === "string" ? JSON.parse(section.content || "{}") : section.content;

    return (
        <h2
            id={`block-${section.sectionCode}`}
            data-anchor-id={section.sectionCode}
            className="text-primary-500 not-first:mt-15"
        >
            {content.text}
        </h2>
    );
};

export default BlockHeader;
